import { createStore, combineReducers } from 'redux';
import entityManagerReducer from './../actions/entityManager';
export const getStore = () => createStore(combineReducers({
  entityManagerReducer
}));
